import { GravyBinder } from 'gravy-bind';
import { loopThroughElements } from './utils/loop-through-elements';
import { Key } from 'ts-key-enum';

export class MegaTab {
    private binder: GravyBinder;
    public currentTab: number = 0;
    public static cssClass: string = 'mega-tab';

    constructor(private rootElement: HTMLElement) {
        this.setTabBindings();
        this.setContentBindings();
        this.binder = new GravyBinder(this, this.rootElement);
        this.binder.updateOutwardBindings();
    }

    private setTabBindings(): void {
        let index = 0;
        loopThroughElements(
            this.rootElement.getElementsByClassName('tab'),
            (tab: HTMLElement) => {
                tab.addEventListener('click', () =>
                    this.onTabSelected(tab.dataset.tab)
                );
                tab.addEventListener('keypress', (event: KeyboardEvent) => {
                    if (event.key == Key.Enter || event.key === ' ') {
                        event.preventDefault();
                        tab.click();
                    }
                });
                tab.dataset.class = 'tab--active';
                tab.dataset.tab = index.toString();
                tab.dataset.classCondition = `this.currentTab == ${index}`;
                index++;
            }
        );
    }

    private setContentBindings(): void {
        let index = 0;

        const tabContentElement = this.rootElement.getElementsByClassName('mega-tab__tab-content')[0] as HTMLElement;

        if (tabContentElement) {
            loopThroughElements(
                tabContentElement.children,
                (el) => {
                    el.classList.add('tab-content__inner');
                    el.dataset.class = 'tab-content__inner--active';
                    el.dataset.classCondition = `this.currentTab == ${index}`;
                    index++;
                }
            );
        } else {
            console.warn('MegaTab: No element found with class "mega-tab__tab-content".');
        }
    }

    private onTabSelected(index: string): void {
        this.currentTab = Number(index);
        this.binder.updateOutwardBindings();
    }
}